import { useEffect, useState } from 'react';
import { FaCircle } from 'react-icons/fa';

const RecordingIndicator = ({ recording }) => {
  
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    let interval;
    if (recording) {
      interval = setInterval(() => {
        setElapsedTime((prev) => prev + 1);
      }, 1000);
    } else {
      setElapsedTime(0); // Reset when recording stops
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [recording]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60).toString().padStart(2, '0');
    const secs = (seconds % 60).toString().padStart(2, '0');
    return `${mins}:${secs}`;
  };

  return (
    recording && (
      <div className="absolute top-2 left-2 bg-red-600 text-white px-2 py-1 rounded-md text-xs flex items-center z-20 space-x-1">
        <FaCircle className="animate-pulse" size={8} />
        <span>REC</span>
        <span className="ml-1 font-mono">{formatTime(elapsedTime)}</span>
      </div>
    )
  );
};

export default RecordingIndicator;
